import { useState } from 'react'
import { reportError } from 'utils/error'
import { useImagePickerContext } from '../ImagePickerContext'

export const useConfirm = () => {
  const context = useImagePickerContext()
  const { selectedImages, onConfirm, uploadImages } = context
  const [isConfirming, setIsConfirming] = useState(false)

  const confirm = async () => {
    if (context.onBeforeConfirm) {
      const confirmed = await context.onBeforeConfirm(selectedImages)
      if (!confirmed) {
        return
      }
    }

    setIsConfirming(true)
    try {
      const files = await Promise.all(
        selectedImages.map(async (image) => {
          const response = await fetch(image.url)
          const blob = await response.blob()
          return new File([blob], image.original_filename || 'filename', { type: blob.type })
        }),
      )
      const uploadedImages = await uploadImages(files, context)
      onConfirm(
        uploadedImages.map((image, i) => ({
          ...image,
          unsplash: selectedImages[i].unsplash,
        })),
        context,
      )
    } catch (error) {
      reportError(error)
    } finally {
      setIsConfirming(false)
    }
  }

  return { confirm, isConfirming }
}
